/*----- Core -----*/
import React  from 'react'
import styled from 'styled-components'

/*----- Components -----*/
import WhatsAppLogo from '../../../assets/landing_page/icons/whatsapp_icon.svg'

/*----- Commons -----*/
import Montserrat from '../../../commons/mixins/fonts/Montserrat'
import Device 		from '../../../commons/Device'

/*----- Styles -----*/
const StyledHeader = styled.header`
	background-color: white;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 16px;
	position: fixed;
	width: 100%;
	top: 0;
	left: 0;
	z-index: 4;
	background-color: white;
	box-shadow: 0px 0px 32px -16px rgb(0 0 0 / 0.3);
	.app-header__logo-container {
		display: flex;
    justify-content: center;
    align-items: center;
		height: 68px;
		padding: 0 0 4px 8px;
		margin: 0;
		.name {
			${ Montserrat(12, 600,'black') };
		}
		.job {
			${ Montserrat(10, 400,'black') };
			margin-left: 16px;
			border-left: 1px solid black;
			padding-left: 16px;
		}
	}
	.app-header__whatsapp-container {
	}
	.app-header__whatsaap-button {
		${ Montserrat(14, 800,'white') };
		background-color: #1bd741;
		display: flex;
    padding: 8px 16px;
    border-radius: 8px;
		align-items: center;
		margin-right: 16px;
		img {
			width: 26px;
			height: 26px;
			margin-right: 8px;
		}
	}
	@media ${Device.md} {
		.app-header__logo-container {
			.name {
				font-size: 14px;
			}
			.job {
				font-size: 14px;
			}
	}

	}
`

/*----- Component -----*/
const Header = () => {

	return(
		<StyledHeader className="app-header">
			<div className="app-header__logo-container">
				 <div className="name">Andrés Reggi</div>
				 <div className="job">Productor Asesor de Seguros</div>
			</div>
			<div className="app-header__whatsapp-container">
				<a href="https://wa.link/845kr2" target="_blank" rel="noopener noreferrer"  className="app-header__whatsaap-button">
					<img src={WhatsAppLogo} alt="whatsapp logo"/>
					HABLEMOS
				</a>
			</div>
		</StyledHeader>
	)
}


export default Header
